export const getCardNum = (num: string) => {
  let cardNum = ""
  let iy = 0
  num.split("").forEach((ch, ix) => {
    if (iy == 3) {
      cardNum += ` ${ch}`
      iy = 0
      return
    }
    cardNum += `${ch}`
    iy += 1
  })
  return cardNum
}

export const getOpName = (item: any) => {
  if (item.operation == "OPERATION_RECEIVED") {
    return item[item.operation].actionName
  } else if (item.operation == "OPERATION_RECALLED") {
    return "Cписание"
  } else if (item.operation == "OPERATION_APPLIED") {
    return "Cписание"
  } else if (item.operation == "OPERATION_COLLECTED") {
    return "Начисление"
  } else {
    return ""
  }
}

export const getOperation = (name: string): string => {
  switch (name) {
    case "operation_adjust":
      return "Начисление бонусов"
    case "operation_visits_adjust":
      return "Начисление кешбэка"
    case "operation_revoke":
      return "Списание бонусов"
    case "operation_pay":
      return "Оплата бонусами"
    case "operation_pay_freeze":
      return "Заморозка бонусов"
    case "operation_life_end":
      return "Сгорание бонусов"
    default:
      return "Корректировка"
  }
}

export const isRecall = (item: any) => {
  return item.operation_name == "operation_pay" || item.operation_name == "operation_pay_freeze" || item.operation_name == "operation_revoke" || item.operation_name == "operation_life_end"
}

export const getPrice = (name: string) => {
  if (name == "sub1") {
    return 500
  } else if (name == "sub2") {
    return 1000
  } else if (name == "sub3") {
    return 2000
  } else {
    return 3000
  }
}

export const getSubName = (name: string) => {
  if (name == "sub1") {
    return "БАЗА"
  } else if (name == "sub2") {
    return "ПЛЮС"
  } else if (name == "sub3") {
    return "ПРО"
  } else if (name == "sub4") {
    return "ТОП"
  } else if (name == "barber") {
    return "БАРБЕР"
  } else if (name == "barber_plus") {
    return "БАРБЕР ПЛЮС"
  }
}

export const getTotalSaleWidth = (totalSale: number, width: number = 0) => {
  let widths: any = {}

  if (width < 768) {
    widths = {20: "20%", 30: "23%", 40: "26%", 50: "29%", 60: "32%", 70: "35%", 80: "57.2%"}
  } else {
    widths = {20: "20%", 30: "22%", 40: "24%", 50: "26%", 60: "28%", 70: "30%", 80: "48.2%"}
  }

  let result = widths[totalSale]

  return result != undefined ? result : widths[0]
}